import { createSelector } from 'reselect';
import { getLocationParams } from '../router/selectors';
import { getTranslate } from 'react-localize-redux';
import { AppConfig } from '../../Api';

export const isLoggedIn = (state: WebOrder.State) =>
  state.flipdish.Customer && state.flipdish.Customer.status === 'success';

//   export const getLoginError = (state: WebOrder.State) =>
//   state.flipdish.Customer && state.flipdish.Customer.status === 'error';

export const getUser = (state: WebOrder.State) =>
  state.flipdish.Customer && state.flipdish.Customer.status === 'success'
    ? state.flipdish.Customer.data
    : undefined;

//#region APP_CONFIG & FEATURE_FLAGS

const getAppConfig = (state: WebOrder.State) =>
  state.flipdish.AppConfig && state.flipdish.AppConfig.status === 'success'
    ? state.flipdish.AppConfig.data
    : ({} as AppConfig);

const getFeatureFlags = (state: WebOrder.State) => getAppConfig(state).Features || [];

/**
 * TEMPORARY FF until added to web-portal config
 */
const getRequestFullNameFF = createSelector<WebOrder.State, string[], boolean>(
  [getFeatureFlags],
  (features) => features.includes('request-full-name')
);

//#endregion

//#region USERNAME

export const getUserNameLabelText = createSelector<
  WebOrder.State,
  WebOrder.State['location']['params']['type'],
  ReturnType<typeof getTranslate>,
  boolean,
  { label: string; description: string }
>(
  [
    (state) => getLocationParams(state).type,
    (state) => getTranslate(state.locale),
    getRequestFullNameFF
  ],
  (deliveryType, translate, requestFullNameFF) => {
    const tId: TranslationId = requestFullNameFF ? 'Full_name' : 'Name';
    const label = translate(tId) as string;
    const description = (deliveryType === 'delivery'
      ? translate('If_the_driver_needs_to_call' as TranslationId)
      : translate('For_when_you_collect' as TranslationId)) as string;

    return {
      label,
      description
    };
  }
);

//#endregion
